// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"8a48b7a9205de903","666":"7cec6ad7f0e7d90f","896":"ff87d0644d00dd2f"}[chunkId] + ".js";
};